<script>
	import Dispatch from './Dispatcher'
	import Fa from 'svelte-fa'
	import { faBars, faStar as faStarLight } from '@fortawesome/pro-regular-svg-icons'
	import { faTruck, faTruckFront, faBeer, faStar } from '@fortawesome/pro-solid-svg-icons'
	import _ from 'lodash'

	import Menu from './components/Menu.svelte'

	let menu = Dispatch.getState('menu')
	let locations = Dispatch.getState('locations')

	export let code
	const options = [{ id:1 }, {id: 2}, {id: 3}, {id: 4}, {id: 5}]
	export let selected

	if (_.isNil(localStorage.getItem('version'))) {
		localStorage.removeItem('token')
		localStorage.setItem('version', 1)
	}
	// const options = [{ id:1 }, {id: 2}, {id: 3}, {id: 4}, {id: 5}].map(option => {
  //   const MultiButton = (props) => {
  //     const selected = props.selected
  //     const selectedClass = selected ? 'white' : 'yellow'
  //     return (
  //       <div className='pt2'>
  //         {selected ?
  //           <div className=' dib f1 yellow' >
  //             <FontAwesomeIcon icon={faStar} />
  //             <div className='relative black f5 fw9' style={{top: -35, left: 22}}>{option.id}</div>
  //           </div>
  //           :
  //           <div className=' dib f1 moon-gray' >
  //             <FontAwesomeIcon icon={faStarLight} />
  //             <div className='relative moon-gray f5 fw9' style={{top: -35, left: 22}}>{option.id}</div>
  //           </div>
  //         }
  //       </div>
  //     )
  //   }
  //   return {...option, component: MultiButton}
  // })

	// <MultiSelect options={options} id={beer.id.toString()} isMultiSelect={false} defaultValue={{[beer.ratedDrinks?.[0]?.rating]:true}} />

</script>

<main class='w-100 avenir pb5 flex justify-center bg-dark-gray'>
	<div class='w-100 pb4 mw6 flex flex-column bg-white'>
		<Menu/>
		<div class='h3 w-100 ph4 bg-black white fw7 f3 bb flex justify-between items-center'>
			<div class=''>East Troy Brewfest</div>
			<div class=' f2 white pointer' on:click={e => {
				Dispatch.nextState('menu.open', !$menu.open)
				}}><Fa icon={faBars}/></div>
		</div>
		<div class='w-100 ph5 pt4'>
			<img class='w-100 border-box' style='object-fit: cover;' src='easttroychamberlogo.svg'/>
		</div>

		<div class='w-100 flex justify-center items-center'>
			<div class="w-100 mw6">
				<div class='w-100 ph3 pt5 flex flex-column justify-center'>
					<img class='w-100' src='brewfest 2026.png' />
				</div>
			</div>
		</div>

				<div class='w-100 mt5 pt4 pb4 bg-black'>
					<div class='ph4 f1 white tc'><Fa icon={faBeer} /><Fa icon={faBeer} /><Fa icon={faBeer} /><Fa icon={faBeer} /><Fa icon={faBeer} /></div>
					<div class='pt5 ph4 f1 fw9 white tc'>Welcome to Brewfest 2026!</div>
					<div class='ph4 pt5 f5 fw4 white tc'>Below you will find a map of Brewfest, and below that your beer rating sheet! We hope you enjoy your stay!</div>
					<!-- <div class='mt5 h3 bg-white'></div>
					<div class='w-100 bg-white'><img class='w-100' src='map.png' /></div>
					<div class='h3 bg-white'></div> -->
				</div>

				<a href='https://getsauced.pizza' class='pt3 link'>
					<div class='w-100 h3 flex justify-center items-center pink'>
						<div class='black f4 fw7'>Sponsored By</div>
						
					</div>
					<div class='w-100'>
						<img class='w-100 border-box' style='object-fit: cover;' src='Sauced Pizzeria Sponsor.png'/>
					</div>
				</a>

				<div class='w-100 pt4 bg-white'><img class='w-100' src='2026BrewFestMap.png' /></div>

				<div class=''>
				
				{#if _.isNil($locations?.length) || $locations?.length === 0}

					<div class='flex flex-column'>
						<div class='pt3 w-100 tc fw7'> Enter your code to begin rating beers! </div>
						<div class='pt2 flex justify-center'> 
							<input 
								class='w-50 pa3 br2 bg-white f5 ba b--moon-gray tc' 
								style='outline: none; border-style: solid;' 
								type="text"
								placeHolder='Entry Code'
								defaultValue=''
								bind:value={code}
							/>
						</div>
						<div class='w-100 flex justify-center'>
							<div class='dib mt2 pa3 br2 bg-blue white tc pointer fw7' on:click={e => Dispatch.nextAction('login', code)}>Submit</div>
						</div>
					</div>
				{:else}
					<div class='w-100 pv5 ph4 bg-gold black f1 fw9 tc b--white bb'>RATE <br/> YOUR <br/> BEER! </div>
					{#each $locations as quad}
					<div class='w-100 flex justify-center'>
						<div class='w-100 mw7'>
							<div class='f3 fw7 bg-black white pa3' style='position: sticky; top:0px; z-index: 1000'>{quad.name}</div>
							<div class=''>
								{#each quad.breweries as station}
									<div class=''>
										<div class='f3 fw7 bg-gray white pa3' style='position: sticky; top:55px; z-index: 900'> {station.name}</div>
										<div class='pt4 pb4'>
											{#each station.drinks as beer}
												<div class='pt4'>
													<div class='ph3 f2 fw9'>{beer.name}</div>
													<div class='ph3 pt1 fw6'>Average Rating: {parseFloat(beer.average ?? 0).toFixed(2)}</div>
													<div class='ph3 pt3 fw4'>{beer.description}</div>
													<div class='w-100 ph4 pt4 flex justify-between'>
														{#each options as option}
															{#if beer.ratedDrinks?.[0]?.rating === option.id }
																<div class=' dib f1 yellow' >
																	<Fa icon={faStar} />
																	<div class='relative black f5 fw9' style='top: -35px; left: 22px'>{option.id}</div>
																</div>
															{:else}
																<div class=' dib f1 moon-gray' >
																	<div on:click={e => Dispatch.nextAction('RateBeer', {id: beer.id.toString(), value: option.id})}>
																		<Fa icon={faStarLight}  />
																	</div>
																	<div class='relative moon-gray f5 fw7' style='top: -37px; left: 22px; pointer-events: none;'>{option.id}</div>
																</div>
															{/if}
														{/each}
													</div>
												</div>
											
											{/each}
										</div>
									</div>
								
								{/each}
							</div>
						</div>
						</div>
						{/each}
						<!-- <div class='w-100 flex justify-center'>
							<div class='dib mt2 pa3 br2 bg-blue white tc pointer' on:click={e => Dispatch.nextAction('logout')}>Sign Out</div>
						</div> -->
				{/if}

						</div>
</main>

<style>


	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>